"use client";

import type { AgentSession } from "@/app/_blocks/BlockInteractCreateOmnibox/demos/Agents/useAgentSession";
import { createContext, useContext, useState } from "react";
import { createStore, useStore, type StoreApi } from "zustand";

type FloatingAgentState = { session: AgentSession | null; setSession: (session: AgentSession) => void };
type FloatingAgentStore = StoreApi<FloatingAgentState>;

const FloatingAgentContext = createContext<{ store: FloatingAgentStore } | null>(null);

export function useFloatingAgentStore<U = FloatingAgentState>(selectorFn: (state: FloatingAgentState) => U) {
  const context = useContext(FloatingAgentContext);
  if (!context) {
    throw new Error("useFloatingAgent must be used within a FloatingAgentProvider");
  }
  return useStore(context.store, selectorFn);
}

export function FloatingAgentProvider({ children }: { children: React.ReactNode }) {
  const [store] = useState(() =>
    createStore<FloatingAgentState>()(set => ({
      session: null,
      setSession: session => {
        set({ session });
      },
    })),
  );
  return <FloatingAgentContext.Provider value={{ store }}>{children}</FloatingAgentContext.Provider>;
}
